(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('area-setup', {
            parent: 'entity',
            url: '/area-setup/{id}',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.agence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agence-setup.html',
                    controller: 'AgenceSetupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            	entity: ['$stateParams', 'Agence', function ($stateParams, Agence) {
                        return Agence.get({id : $stateParams.id});
                  
                }],
                templateEntity: [function () {
                    return null;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('area-template-setup', {
            parent: 'entity',
            url: '/area-template-setup/{id}',
            data: {
                authorities: ['ROLE_AREA_CONFIGURATION', 'ROLE_READ_ONLY'],
                pageTitle: 'global.menu.areaTemplates'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agence-template-setup.html',
                    controller: 'AgenceSetupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Agence', function ($stateParams, Agence) {
                    return Agence.get({id : $stateParams.id});

                }],
                templateEntity: ['$stateParams', 'AgenceTemplate', function ($stateParams, AgenceTemplate) {
                    return AgenceTemplate.get({idArea : $stateParams.id}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agence', {
            parent: 'entity',
            url: '/agence?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_READ_ONLY'],
                pageTitle: 'wamasysApp.agence.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agences.html',
                    controller: 'AgenceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('agence-detail', {
            parent: 'entity',
            url: '/agence/{id}',
            data: {
                authenticate: true,
                pageTitle: 'wamasysApp.agence.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/agence/agence-detail.html',
                    controller: 'AgenceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('agence');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Agence', function($stateParams, Agence) {
                    return Agence.get({id : $stateParams.id});
                }]
            }
        })
        .state('agence.new', {
            parent: 'agence',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/agence/agence-dialog.html',
                    controller: 'AgenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nom: null,
                                codeAgence: null,
                                devise: null,
                                enteteFacture: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('agence', null, { reload: true });
                }, function() {
                    $state.go('agence');
                });
            }]
        })
        .state('agence.edit', {
            parent: 'agence',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/agence/agence-dialog.html',
                    controller: 'AgenceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Agence', function(Agence) {
                            return Agence.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agence', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('agence.delete', {
            parent: 'agence',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/business/agence/agence-delete-dialog.html',
                    controller: 'AgenceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Agence', function(Agence) {
                            return Agence.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('agence', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
